export default __webpack_public_path__ + "86b254d1f39c6b80d916be137df16a8c.svg";